import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const AGBText = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 6
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        px: {
          md: '130px !important'
        }
      }}
    >
      <Typography
        color="textSecondary"
        sx={{ mb: 2 }}
        variant="body1"
        align="justify"
      >
        <h3>eyerena Nutzungsbedingungen</h3>
        Die digitale Lernplattform eyerena bietet Nutzer:innen an, Übungen, Schüler,
        Termine und Trainingspläne im Bereich Visual- und Kognitionstraining zu verwalten.
        <br />
        <br />
        <h3>Mitgliedschaft</h3>
        Die eyerena Mitgliedschaft ist im Rahmen der aktuellen, erweiterten Testphase kostenlos.
        Voraussichtlich endet die Beta-Testphase zum 31.12.2022. Sämtliche bis dahin angebotene
        Funktionen und Inhalte sind kostenlos. Nach der Beta-Testphase werden die eyerena Mitglieder
        einer kostenlosen Basis Version zugeordnet. Parallel zu der kostenlosen Basis Version wird eine
        gebührenpflichtige Trainer bzw. Trainer Pro Version zur Nutzung freigegeben. Eine Erweiterung der Nutzung der Plattform durch
        eyerena Nutzer:innen auf eine Trainer bzw. Trainer Pro Version erfolgt ausdrücklich nur auf deren Wunsch durch
        Auswahl und anschließende Benachrichtigung, dies betrifft auch damit verbundene anfallende Gebühren.
        <br />
        <br />
        <h3>Zugang und Nutzung der Lernplattform</h3>
        Zur Nutzung der Lernplattform müssen sich Nutzer mit ihren Daten registrieren und einen Account anlegen.
        Jeder Nutzer erhält so einen persönlichen Zugang zur Lernplattform. Eine Weitergabe der Zugangsdaten an
        Dritte ist nicht gestattet.
        <br />
        <br />
        <h3>Passwörter und Zugriff auf eyerena</h3>
        Das Mitglied, das das eyerena Konto erstellt hat, ist für jegliche mit dem eyerena Konto in Verbindung stehende
        Aktivitäten verantwortlich. Das Mitglied ist dafür verantwortlich, die im Zusammenhang mit dem eyerena Konto
        bereitgestellten Informationen zu aktualisieren und stets dafür zu sorgen, dass diese auf dem neuesten Stand sind. Um
        das Mitglied, eyerena oder unsere Partner vor Identitätsdiebstahl oder anderen betrügerischen Aktivitäten zu schützen,
        behält eyerena sich das Recht vor, die Mitgliedschaft zu beenden oder das Konto vorübergehend stillzulegen.
        <br />
        <br />
        <h3>Kündigung</h3>
        Du kannst die eyerena Mitgliedschaft jederzeit kündigen. Um zu kündigen, schreibe uns bitte eine Nachricht
        an hello@eyerena-training.de.
        <br />
        <br />
        <h3>Mitwirkungspflicht des Mitglieds</h3>
        Für die Nutzung und Verwendung unserer Plattform sind technische Voraussetzungen notwendig, wie beispielsweise ein
        kompatibles Betriebssystem, Webbrowser und eine Internetverbindung mit ausreichender Bandbreite. Das Mitglied ist selbst
        für die Schaffung der jeweils notwendigen Voraussetzungen verantwortlich. Kann unsere Leistung durch das Mitglied nicht
        genutzt werden und ist dies auf mangelnde Voraussetzungen auf Mitgliederseite zurückzuführen, so sind entsprechende Mängelansprüche
        des Mitglieds ausgeschlossen.
        <br />
        <br />
        <h3>Verfügbarkeit der Lernplattform</h3>
        Wir bemühen uns darum, den Zugang zu eyerena permanent sicher zu stellen. Können jedoch keine Garantie aussprechen
        für den erfolgreichen Abruf von Inhalten zu jeder Zeit und in jedem Einzelfall. Aus technischen Gründen, beispielsweise
        durch ein neues Update oder aufgrund von Wartungsarbeiten kann der Zugriff zeitweise eingeschränkt sein.
        <br />
        <br />
        <h3>Anpassungen am Inhalt</h3>
        Wir behalten uns ausdrücklich vor, Teile oder den gesamten Inhalt unserer angebotenen Inhalte, wie Übungen, ohne gesonderte
        Ankündigung zu verändern, zu ergänzen, zu löschen oder die Bereitstellung zeitweise oder endgültig einzustellen. Unsere
        Vertragspflichten bleiben hiervon unberührt.
        <br />
        <br />
        <h3>Haftung und Sicherheit bei Übungen</h3>
        Alle eyerena Mitglieder haben die Möglichkeit, auf eyerena eigene Übungen zu erstellen und hochzuladen sowie auf vordefinierte
        Übungen im Bereich “alle Übungen” zuzugreifen. Sie haben als Trainer die Einwandfreiheit und Sicherheit der Durchführung dieser
        Übungen in vollem Umfang sicher zu stellen und übernehmen die volle Haftung in allen Schadensfällen, die aus einer Verletzung dieser
        Sorgfaltspflicht entstehen. Dies gilt insbesondere für alle etwaigen Schäden, Verletzungen und andere Einschränkungen, die während der
        Ausführung der beschriebenen Übungstypen entstehen könnten. Der Trainer hat seiner Sorgfaltspflicht gegenüber seinen Schülern in allen
        Fällen stets nachzukommen. Er haftet für seine Übungen in vollem Umfang und trägt das ganze Risiko für diese in der Ausführung und Vermittlung.
        eyerena schließt jegliche Haftung für die von den Trainern selbst erstellten, verwalteten und mit ihren Schülern genutzten Übungen in allen
        möglichen Fällen aus.
        <br />
        <br />
        <h3>Datenschutz</h3>
        Informationen zum Datenschutz im Zusammenhang mit denen auf eyerena angebotenen Diensten findest Du in unserem Datenschutzkonzept.
        <br />
        <br />
        <h3>Externe Webseiten</h3>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen
        wir ausdrücklich weder Gewähr noch Haftung. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
        Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ohne konkrete Anhaltspunkte einer Rechtsverletzung
        ist jedoch nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden derartige Links natürlich umgehend durch uns entfernt. Für Hinweise hierzu
        sind wir dankbar und bitten bei Auffälligkeiten um Benachrichtigung an hello@eyerena-training.de.
        <br />
        <br />
        <br />
        <br />
        Letzte Aktualisierung: 09. November 2022
      </Typography>
    </Container>
  </Box>
);

export default AGBText;
